const apiUrl = process.env.REACT_APP_API_ENDPOINT;
export default apiUrl;
